<div class="picture">
  <div class="icon">
    <ion-icon name="alberta-dot"></ion-icon>
  </div>
  <div class="text-wrapper">
    <div class="title">{{ node.title }}</div>
    <div class="description bold" *ngIf="node.description">{{ node.description }}</div>
    <itl-loading-indicator *ngIf="busy"></itl-loading-indicator>
    <div class="image-wrapper" *ngIf="!busy && image?.data">
      <img [src]="image.data" (click)="showEditImageActionSheet()" />
    </div>
  </div>
</div>
<img #markerImageElement [src]="markerImage" style="visibility: hidden; position: absolute;" />
